<template>
    <div class="container-xxl py-5">
        <!-- Duyuru Kartı -->
        <div class="container my-5">
            <div ref="captureArea" class="announcement-card mx-auto">
                <div class="card radius shadow">
                    <!-- Üst Logo -->
                    <div class="card-header text-center">
                        <img src="/img/logo.png" alt="Dernek Logosu" class="logom mb-1" />
                    </div>

                    <!-- Gövde -->
                    <div class="card-body text-center">
                        <!-- Dernek İçi Görsel -->
                        <img src="/img/kolaj2.jpg" alt="Dernek İçi Görsel" class="img-fluid rounded mb-4" />

                        <p class="fw-bold fs-5 mb-3">
                            Dernek binamız artık <strong>hizmete hazır!</strong>
                            <strong> 250 m²</strong> genişliğinde, <strong>150 kişilik</strong> salonumuzda
                            <span class="text-success">düğün, nişan, toplantı, taziye, doğum günü</span> gibi tüm
                            organizasyonlarınızı
                            <strong>ücretsiz</strong> şekilde gerçekleştirebilirsiniz.
                        </p>

                        <p class="text-muted fst-italic mb-2">
                            Rezervasyonlar için hemen bizimle iletişime geçin, birlikte planlayalım.
                        </p>

                        <p class="fw-bold text-primary">
                            Rezervasyon: <a href="tel:+905079217404">0507 921 7404</a>
                        </p>

                        <p class="text-secondary">
                            Dernek olarak amacımız; üyelerimizin ve hemşehrilerimizin özel günlerinde yanlarında olmak.
                            Organizasyonlarınız için binamızdan <strong>ücretsiz</strong> şekilde yararlanabilirsiniz.
                        </p>

                    </div>

                    <!-- Alt Bilgi -->
                    <div class="card-footer text-center">
                        <img src="/img/logo.jpg" alt="Dernek Logosu" style="height: 80px; border-radius: 50%;"
                            class="me-2 mt-2" />
                        <small class="text-muted d-block fst-italic mt-2">
                            Başkent Ağrılılar Eğitim, Kültür ve Sosyal Yardımlaşma Derneği
                        </small>
                        <small class="text-muted d-block mt-1">
                            İletişim: <a href="tel:+905079217404">0507 921 7404</a>
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <!-- PNG İndirme Butonu -->
        <div class="text-center mt-3">
            <button @click="downloadAsPng" class="btn btn-success">
                Görseli PNG Olarak Kaydet
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import html2canvas from 'html2canvas'

const captureArea = ref(null)

const downloadAsPng = async () => {
    if (!captureArea.value) return
    const canvas = await html2canvas(captureArea.value, {
        backgroundColor: '#ffffff',
        scale: 1,
    })
    const link = document.createElement('a')
    link.download = 'duyuru.png'
    link.href = canvas.toDataURL('image/png')
    link.click()
}
</script>

<style scoped>
.logom {
    height: 80px;
}

.announcement-card {
    max-width: 600px;
}

.qr-code {
    width: 350px;
    border: 2px solid #eee;
    border-radius: 8px;
    padding: 5px;
    background-color: #fff;
}

.iban-box {
    background-color: #f9f9f9;
}

.card {
    border-radius: 1rem;
}

.card-header {
    background-color: #f8f9fa;
    border-bottom: none;
}

.card-footer {
    background-color: #f8f9fa;
    border-top: none;
}
</style>
